/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Component } from "react";
import AsignCard from "../../../components/Card/Assign";
import ViewCard from "../../../components/Card/Assign/ViewCard";
import { Modal, Popover, Spin, Tabs, Icon, Input } from "antd";
import postService from "../../../services/httpService";
import userTrackService from "../../../services/usertrack-service";
import Storage from "../../../services/local-store";
import Inputlayer from "../../../components/FormComponent/Input";
import { patientSchema } from "../../../schema/token";
import searchIcon from "../../../assets/images/searchicon.svg";
import Search from "antd/lib/input/Search";
import * as R from "ramda";
import TabView from "../../../components/TabView.js";
import moment from "moment";
import {socket} from "./../../../components/Card/Assign/index.js";
import OperatorView from "../OperatorView.js";

const { confirm } = Modal;

class QueuepatientDetailshell extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
      queueitem: this.props.item ? this.props.item : [],
      parentthis: this,
      searchVal: "",
      searchedPatients: "",
      searchCompletedPatients: [],
      searchTotalPatients: [],
      patientIds:[], 
      searchTab: '',
      tabContent : [
        { key: 1, text: "Que" ,title: "In-progress", icon_type: "hourglass" },
        { key: 2, text: "Done" ,title: "Completed", icon_type: "check-circle" },
        { key: 3, text: "All" ,title: "Total", icon_type: "database" },
      ]
    };
  }

  componentDidMount(){
 
  
  this.setState({queueitem: this.props.item ? this.props.item : []});
}
  componentDidUpdate(prevProps) {
    if (this.props.item.patients !== prevProps.item.patients) {
      let queueitem = this.state.queueitem;
      // if (socket.readyState === WebSocket.OPEN) {
      //   // this.onStartQ(queueitem, "withoutassign")
      //   const jsonString = JSON.stringify({data:queueitem,action:"assign"});
      //   socket.send(jsonString);
      // };
   this.refreshSingleQueue(queueitem, "assign");
    }
  }
  refreshQueueListData() {
    this.props.refreshQueueListData();
  }
  refreshData(QueueList, billingPatients) {
    this.props.refreshData(QueueList, billingPatients);
  }
  formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
  }
  checkReBuildQ(queueitem, that) {
    confirm({
      title: "Do you Want to Re-build the Queue 3?",
      content: "",
      onOk() {
        let queuelistid = queueitem.queuelistid || "";
        if (queuelistid !== undefined && queuelistid !== null) {
          let obj = {
            queueListId: queuelistid,
          };
          let Userlogobj = {
            user: JSON.parse(Storage.get("user")),
            action: "restore queue",
            date: new Date(),
            meta: obj,
          };
          userTrackService(Userlogobj);
          postService("restoreQueueById", "POST", { data: obj }).then((res) => {
            let Userlogobjres = {
              user: JSON.parse(Storage.get("user")),
              action: "restore queue - response",
              date: new Date(),
              meta: res,
            };
            userTrackService(Userlogobjres);
            if (res) {
              //that.refreshQueueListData();
              if (socket.readyState === WebSocket.OPEN) {
                console.log('WebSocket connection established ++Rebuild.');
                // this.onStartQ(queueitem, "withoutassign")
                const jsonString = JSON.stringify({data:obj,action:"rebuild"});
                socket.send(jsonString);
              };
              //that.refreshSingleQueue(obj, "rebuild");
            }
          });
        }
      },
      onCancel() {
      },
    });
  }
refreshSingleQueue(queueitemm, action) {
  // console.log("Refresh Single Queue22 ",queueitemm);
     console.log("type123456",action);
     // let queueitem=JSON.parse(queueitemm);
  let queueitem;
    if(typeof queueitemm=== 'string'){
      // console.log("typeeee");
      // console.log("tyepp",JSON.parse(queueitem),typeof JSON.parse(queueitem ));
    queueitem=JSON.parse(queueitemm);
    }

    else{
       queueitem=queueitemm;
    }
    // console.log("pprr1",this.props.roomId,queueitem.roomnumber);

    //console.log("type123456QueueItem",queueitem);
    let queuelistid = queueitem.queuelistid || queueitem.queueListId;
    let new_queuelistid="";
    if(queueitem.new_queuelistid){
    new_queuelistid=queueitem.new_queuelistid;}
    if (queuelistid !== undefined && queuelistid !== null) {
      let obj = {
        patientId:queueitem.patientId || '',
        queueListId: queuelistid,
        action: action,
        new_queuelistid:new_queuelistid,
      };
      if (action === "manualRefresh") this.props.activateLoader();
      postService("refreshQueueById", "POST", { data: obj }).then((res) => {
        console.log("refreshbyid-----5");
        if(action !== 'checkinfs'){
        this.props.deActivateLoader();
        this.props.setlastRefreshedAt(moment());}
      // console.log("pprr",this.props.roomId,queueitem.roomnumber);
         
          // const opview=new OperatorView();
          // opview.deActivateLoader();
          // opview.setlastRefreshedAt(moment());
      
        if (res) {
          let queueinfo = res.data || {};
          //console.log("queueinfo",queueinfo);
  //        socket.on('message', (message) => {
  //  console.log(`Received message from checkin api: ${message}`);});
          // socket.addEventListener('open', (event) => {
          //   console.log('Connected to WebSocket server ccc.');
          // });
          
          // // // Event listener for when a message is received from the server
          //  socket.addEventListener('message', (event) => {
          //   console.log('Message from server ccc', event.data);})
          // socket.onmessage = (event) => {
          //   const message = event.data;
          //   console.log(`RReceived message from server in checkin: ${message}`);
          //   // Handle incoming messages from the server as needed
          // };
        //  console.log("1queueItem",queueitem, queueinfo);
          // if(this.props.roomId==queueitem.roomnumber)
         this.state.parentthis.setState({ queueitem: queueinfo });
        }
      });
    }
  }

  handleChange(event) {
    let fields = this.state.fieldData;
    fields.map((field, key) => {
      if (event.name === field.name) {
        this.state.fieldData[key]["valid"] = true;
        this.state.fieldData[key]["value"] = event.value;
        this.state.fieldData[key]["errors"] = [];
      }
    });
  }

  getSearchResults(value, type) {
    
    let actualPatients = [];
    if(type === 'in-progress'){
      actualPatients = this.state.queueitem.patients || [];
    }
    else if(type === 'completed'){
      actualPatients = this.state.queueitem.completedPatients || [];
    }
    else{
      actualPatients = this.state.queueitem.totalPatients || [];
    }

    this.setState({ searchVal: value });
    if (value) {
      let searchKey = value;
      let searchresults = actualPatients.filter((s) => {
        if (
          R.includes(R.toLower(searchKey), R.toLower(s.name ? s.name : "null"))
        ) {
          return s;
        } else if (
          R.includes(R.toLower(searchKey), R.toLower(s.umr ? s.umr : "null"))
        ) {
          return s;
        } else if (
          R.includes(
            R.toLower(searchKey),
            R.toLower(s.patienttype ? s.patienttype : "null")
          )
        ) {
          return s;
        }
      })
      if(type === 'in-progress'){
        this.setState({ searchedPatients: searchresults, searchTab: 1 });
      }
      else if(type === 'completed'){
        this.setState({ searchCompletedPatients: searchresults, searchTab: 2 });
      }
      else{
        this.setState({ searchTotalPatients: searchresults, searchTab: 3 });
      }
      // this.setState({ searchedPatients: searchresults });
    } 
    else {
      if(type === 'in-progress'){
        this.setState({ searchedPatients: actualPatients });
      }
      else if(type === 'completed'){
        this.setState({ searchCompletedPatients: actualPatients });
      }
      else{
        this.setState({ searchTotalPatients: actualPatients });
      }
      // this.setState({ searchedPatients: actualPatients });
    }
  }

  onTabClick = (tab_key) => {
    this.setState({searchVal: ''});
    if(tab_key === 1){
      // this.setState({billingPatients: []});
      this.setState({searchTotalPatients: []});
    }
    else if(tab_key === 2){
      this.setState({billingPatients: []});
      this.setState({searchTotalPatients: []});
    }
    else{
      this.setState({billingPatients: []});
      this.setState({searchTotalPatients: []});
    }
  };

  render() {
    // console.log("just", this.props.item,this.state.queueitem)
    let queueitem = this.state.parentthis.state.queueitem;
    //  console.log("propsssss",this.props.roomId,queueitem.roomnumber);
    // console.log("queue",queueitem);
    let that = this;
    let rebuildStatus = queueitem.rebuildStatus;
  let department_ids=this.props.department_ids;
  // console.log("spcl Data",spcl_code_data);
    let { searchVal, searchTab, searchedPatients, searchCompletedPatients, searchTotalPatients, tabContent } = this.state
    // let displayPatients = this.state.searchedPatients
    //   ? this.state.searchedPatients
    //   : queueitem.patients;
    // searchTab
    let displayPatients = searchVal && searchTab === 1 ? searchedPatients : queueitem.patients;
    let completedPatients = searchVal && searchTab === 2 ? searchCompletedPatients : queueitem.completedPatients;
    let totalPatients = searchVal && searchTab === 3 ? searchTotalPatients : queueitem.totalPatients;
    // let completedPatients = queueitem.completedPatients;
    // let totalPatients = queueitem.totalPatients;
    
    let QType = this.props.item.queue_type;



    return (
      <>
      {/* {console.log("queueitem6789096",queueitem)} */}
        <div className="row d-none"  >
          {/* {console.log("queueitem refreshSingleQueue", queueitem)} */}
          <div className="col-6" >
            {/* <span class="PatientsTitle">{`Patients (${queueitem.patients.length})`}</span> */}
            <span className="PatientsTitle">{`Patients (${queueitem && queueitem.patients ? queueitem.patients.length : 0})`}</span>
          </div>
           <div className="col-6">
            <div className="row ml-5 mb-0">
              <Popover
                overlayClassName="popover-custom"
                placement="top"
                title={""}
                content={"Refresh"}
              >
                <figure
                  className="col py-1 mb-0 text-left"
                  onClick={this.refreshSingleQueue.bind(
                    this,
                    queueitem,
                    "manualRefresh"
                  )}
                >
                  <img
                    src="/assets/images/icons/refresh.png"
                    alt="refresh"
                    draggable={false}
                  />
                </figure>
              </Popover>
              <Popover
                overlayClassName="popover-custom"
                placement="topRight"
                title={""}
                content={"Reset Queue"}
              >
                <figure
                  className="col py-1 mb-0 text-center"
                  onClick={this.checkReBuildQ.bind(this, queueitem, that)}
                >
                  <img
                    src="/assets/images/icons/re_build.png"
                    alt="rebuild"
                    draggable={false}
                  />
                </figure>
              </Popover>
            </div>
          </div>
        </div>
         {patientSchema.feilds.map((field, key) => {
          if (field.element === "input") {
            return (
              <div class="row mb-2 d-none" key={key} >
                
                <div class="col-10 pr-0">
                  {/* <Inputlayer
                    key={key}
                    // {...this.props}
                    // {...this.state}
                    feildData={field}
                    onInputChanges={this.handleChange.bind(this)}
                  /> */}
                  <Search
                    value={this.state.searchVal}
                    allowClear={true}
                    onChange={(e) => this.getSearchResults(e.target.value)}
                  />
                </div>
                <div class="biller-search-icon">
                  <img
                    src={searchIcon}
                    alt=""
                    className="biller-search-icon-img"
                    draggable={false}
                  />
                </div>
              </div>
            );
          }
        })}
        <div className="PatientCardsDisplayScroll">
          {/* <p>Hello</p> */}
          {rebuildStatus && (
            <div class="m-3 py-1 b-card-body">
              <div class="row">
                <div class="col-12 py-4">
                  <div class="row">
                    <p class="text-error text-center col-12 error-color">
                      Please reset the Queue
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}
 
          {QType === "OPD Consultation"  ? (
            <div>
            <TabView
            department_ids={department_ids}
              {...this.props}
              roomId={this.props.roomId}
              tabContent={tabContent}
              queueitem={queueitem}
              doctor_break_time={queueitem.doctor_break_time}
              displayPatients={displayPatients}
              completedPatients={completedPatients}
              totalPatients={totalPatients}
              refreshSingleQueue={this.refreshSingleQueue.bind(this)}
              checkReBuildQ={this.checkReBuildQ.bind(this, queueitem, that)}
              formatAMPM={this.formatAMPM.bind(this)}
              refreshData={this.refreshData.bind(this)}
              activateLoader={this.props.activateLoader.bind(this)}
              deActivateLoader={this.props.deActivateLoader.bind(this)}
              isvitalsRequire_nullornot={this.props.isvitalsRequire_nullornot.bind(this)}
              getSearchResults={this.getSearchResults.bind(this)}
              searchVal={this.state.searchVal}
              hide={this.hide}
              onTabClick = {this.onTabClick}
            /></div>
          ) : (
            displayPatients && displayPatients.map((item, index) => {
              let previous_patient_service_time = 0;
              let service_time, slottime;
              queueitem && queueitem.patients && queueitem.patients.map((s, u) => {
                if (u < index) {
                  let kservicetime = s.service_time || 0;
                  previous_patient_service_time =
                    parseInt(previous_patient_service_time) +
                    parseInt(kservicetime);
                }
              });
              service_time = previous_patient_service_time;
              var dt = new Date();
              dt.setMinutes(dt.getMinutes() + service_time);
              slottime = this.formatAMPM(dt);
              
              return (
                <div>
                <AsignCard
                  department_ids={department_ids}
                  {...this.props}
                  item={item}
                  queueitem={queueitem}
                  singleQueueList={[queueitem]}
                  itemindex={index}
                  refreshData={this.refreshData.bind(this)}
                  slottime={slottime}
                  fullslottime={dt}
                  key={index}
                  activateLoader={this.props.activateLoader.bind(this)}
                  deActivateLoader={this.props.deActivateLoader.bind(this)}
                  refreshSingleQueue={this.refreshSingleQueue.bind(this)}
                  isvitalsRequire_nullornot={this.props.isvitalsRequire_nullornot.bind(this)}
                /></div>
              );
            })
          )}
        </div>
      </>
    );
  }
}

export default QueuepatientDetailshell;
